export enum ReferralStep {    
    PatientStep1 = 1,
    PatientStep2 = 2,
    PatientStep3 = 3,
    PatientCenterSelection = 4,
    DonorStep1 = 11,
    DonorStep2 = 12,
    DonorStep2B = 13,
    DonorStep3 = 14,
    DonorStep3N = 16,
    DonorCenterSelection = 15,
    Complete = 100,
    NddComplete = 101,
    PwodComplete = 102,
    Stop = 200
}